import { Components, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { createGradient } from "theme/palette";

export const MuiTableRow: Components<Theme>["MuiTableRow"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      transition: theme.transitions.create(["background-color"], {
        duration: theme.transitions.duration.shortest,
      }),
      "&:hover": {
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.02)"
            : "rgba(0,0,0,0.015)",
      },
    }),
    selected: ({ theme }) => ({
      backgroundColor: `${theme.palette.primary.main}08 !important`,
    }),
  },
};

export const MuiTableCell: Components<Theme>["MuiTableCell"] = {
  styleOverrides: {
    root: {
      borderBottom: "none",
      padding: "14px 16px",
    },
    head: ({ theme }) => ({
      color: theme.palette.text.secondary,
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.grey[800], 0.5)
          : theme.palette.grey[50],
      fontWeight: 600,
      fontSize: "0.75rem",
      textTransform: "uppercase" as const,
      letterSpacing: "0.05em",
      "&:first-of-type": {
        paddingLeft: theme.spacing(4),
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
      },
      "&:last-of-type": {
        paddingRight: theme.spacing(4),
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
      },
    }),
    stickyHeader: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      backgroundImage: createGradient(
        alpha("#919EAB", 0.08),
        alpha("#919EAB", 0.08)
      ),
    }),
    body: ({ theme }) => ({
      "&:first-of-type": {
        paddingLeft: theme.spacing(4),
      },
      "&:last-of-type": {
        paddingRight: theme.spacing(4),
      },
    }),
  },
};

export const MuiTablePagination: Components<Theme>["MuiTablePagination"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderTop: `solid 1px ${theme.palette.divider}`,
    }),
    toolbar: {
      height: 64,
    },
    select: ({ theme }) => ({
      "&:focus": {
        borderRadius: 12,
      },
    }),
    selectIcon: {
      width: 20,
      height: 20,
    },
  },
};
